export default "__VITE_ASSET__Dg18G2BE__"